import React from 'react';
import PropTypes from 'prop-types';

import EventNameSearchBar from './EventNameSearchBar';
import EventIDSearchBar from './EventIDSearchBar';

import { FILTER_KEYS } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

import SEARCH_BAR_PROPS from './shared/SEARCH_BAR_PROPS';

export default function EventSearchBar({ searchType }) {
  const isEventNameSearch = searchType === FILTER_KEYS.EVENT_NAMES;
  if (isEventNameSearch) {
    return <EventNameSearchBar {...SEARCH_BAR_PROPS} />;
  }

  return <EventIDSearchBar {...SEARCH_BAR_PROPS} />;
}

EventSearchBar.propTypes = {
  searchType: PropTypes.string.isRequired,
};
